import { Outlet } from '@remix-run/react';
import { useTypedRouteLoaderData } from 'remix-typedjson';
import { type loader as rootLoader } from '#buyer-portal/root';
import { useLayoutTitleKey } from '#common/hooks/useLayoutTitleKey';
import { useEditableTranslation } from '#common/i18n/edit-mode.tsx';
import LoginLayout from '#common/layouts/loginLayout.tsx';

export default function Layout() {
    const { baseUrl } = useTypedRouteLoaderData<typeof rootLoader>('root')!;
    const titleKey = useLayoutTitleKey();
    const { t } = useEditableTranslation('auth');

    return (
        <div className='h-full w-full'>
            <LoginLayout title={titleKey ? t(`titles.${titleKey}`) : undefined} baseUrl={baseUrl}>
                <Outlet />
            </LoginLayout>
        </div>
    );
}
